// LA LISTA DE "ACCIONES DEL EQUIPO" (felicitación enviada, firma pedida...).
//
// El servidor es quien las guarda; el navegador tiene una copia (dkt6_team_actions)
// que se rehace cada 45 s con lo que manda el servidor, más lo que este usuario
// acaba de hacer y el servidor todavía no confirma (el envío es "dispara y
// olvida", y el refresco puede llegar antes que él).
//
// Lissette, 2026-10-27 (aviso E6): esa copia ocupaba 4 MB de los 10 que tiene el
// navegador. "Lo que el servidor todavía no confirma" se guardaba PARA SIEMPRE:
// toda marca que ya no venía en las últimas 1000 del servidor (o que era de otra
// agencia en la que ella entró) se quedaba como "pendiente" en cada refresco, y
// la lista solo crecía. Ahora una marca local solo se conserva si es de este
// usuario y de hace menos de VENTANA_PENDIENTE_MS: tiempo de sobra para que el
// envío llegue al servidor. Pasado eso, lo que manda es el servidor.

export const VENTANA_PENDIENTE_MS = 10 * 60 * 1000;

/**
 * Lo que el servidor devuelve + las marcas locales recientes de este usuario que
 * el servidor aún no tiene (misma `key`, que es como el servidor las deduplica).
 */
export function fusionarAccionesDelEquipo(delServidor, previas, { userId, ahora = Date.now(), ventanaMs = VENTANA_PENDIENTE_MS } = {}) {
  const servidor = Array.isArray(delServidor) ? delServidor : [];
  const claves = new Set(servidor.map((a) => a && a.key));
  const pendientes = (Array.isArray(previas) ? previas : []).filter((a) => {
    if (!a || !a.key || claves.has(a.key)) return false;
    if (!userId || a.userId !== userId) return false;
    const t = Date.parse(a.ts);
    return Number.isFinite(t) && ahora - t < ventanaMs;
  });
  return [...servidor, ...pendientes];
}

/**
 * Junta varias listas del servidor en una, sin repetir `key` (la primera gana).
 * Las últimas 1000 acciones + TODAS las marcas de los cumpleaños que vienen: sin
 * la segunda, un cumpleaños programado con meses de antelación quedaba fuera de
 * las 1000 y el aviso decía que no estaba programado (E-399).
 */
export function unirPorClave(...listas) {
  const vistas = new Set();
  const out = [];
  for (const lista of listas) {
    for (const a of Array.isArray(lista) ? lista : []) {
      if (!a || !a.key || vistas.has(a.key)) continue;
      vistas.add(a.key);
      out.push(a);
    }
  }
  return out;
}

/** El rango de fechas de cumpleaños cuyas marcas se cargan siempre: de hace una semana a dentro de 13 meses. */
export function rangoDeCumpleanos(hoy = new Date()) {
  const dia = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  const desde = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() - 7);
  const hasta = new Date(hoy.getFullYear(), hoy.getMonth() + 13, hoy.getDate());
  return { desde: dia(desde), hasta: dia(hasta) };
}
